<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { Button } from "iview";
export default {
  name: "App"
};
</script>

<style>
#app {
  font-family: "PingFang SC", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>



// WEBPACK FOOTER //
// src/App.vue